import { isNotNil } from "client/Misc/utils";
import {
	useCallback,
	useContext,
	useMemo,
	KeyboardEvent
} from "react";
import { DropOverContext } from "client/Components";
import { useKeyboardListNavigationItem } from "client/Hooks";
import { Key } from "client/Misc/commonTypes";

export type UseGlobalSearchItemActionsParams = {
	itemIndex: number;
	shouldNotAutoCloseContainingDropOver?: boolean;
	onExecute: () => void;
};

export type UseGlobalSearchItemActionsResult = {
	ref: (element: HTMLElement | null) => void;
	onKeyDown: (event: KeyboardEvent<HTMLElement>) => void;
};

export const useGlobalSearchItemActions = (
	params: UseGlobalSearchItemActionsParams
): UseGlobalSearchItemActionsResult => {
	const {
		itemIndex,
		shouldNotAutoCloseContainingDropOver,
		onExecute
	} = params;

	const {
		onClose: onCloseDropOver
	} = useContext(DropOverContext);

	const executeHandler = useCallback(
		(): void => {
			if (!shouldNotAutoCloseContainingDropOver && isNotNil(onCloseDropOver)) {
				onCloseDropOver();
			}

			onExecute();
		},
		[
			shouldNotAutoCloseContainingDropOver,
			onCloseDropOver,
			onExecute
		]
	);

	const {
		ref,
		onKeyDown
	} = useKeyboardListNavigationItem({
		itemIndex,
		onExecute: executeHandler,
		executeKey: [
			Key.Enter,
			Key.Space
		]
	});

	return useMemo(
		(): UseGlobalSearchItemActionsResult => ({
			ref,
			onKeyDown
		}),
		[
			ref,
			onKeyDown
		]
	);
};
